import { createClient } from '@supabase/supabase-js';
import { logger } from '../utils/logger';

// Initialize Supabase client
// Try environment variables first
let supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
let supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Fallback to hardcoded values if environment variables are not available
if (!supabaseUrl || !supabaseAnonKey) {
  logger.warn('Using fallback Supabase credentials - this should only be used for testing.');
  supabaseUrl = 'https://qypcxbazannfdzedkclz.supabase.co';
  supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF5cGN4YmF6YW5uZmR6ZWRrY2x6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE3OTgyMjcsImV4cCI6MjA1NzM3NDIyN30.wDw08jMNKSK8hBX9d7QWsWPtTzURxt-FlQ_LwSZI-vs';
}

// Log what we're using without exposing the full key
logger.log(`Using Supabase URL: ${supabaseUrl}`);
logger.log(`Using Supabase Anon Key: ${supabaseAnonKey.substring(0, 5)}...${supabaseAnonKey.substring(supabaseAnonKey.length - 5)}`);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// User session type
export type UserSession = {
  user: {
    id: string;
    email?: string;
  } | null;
  session: any;
};

// Auth-related helper functions
export const authHelpers = {
  // Sign up with email and password
  signUp: async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    });
    
    if (error) throw error;
    return data;
  },
  
  // Sign in with email and password
  signIn: async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    
    if (error) throw error;
    return data;
  },
  
  // Sign out
  signOut: async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  },
  
  // Get current session
  getSession: async () => {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    return data;
  },
  
  // Get current user
  getUser: async () => {
    const { data, error } = await supabase.auth.getUser();
    if (error) throw error;
    return data;
  },
  
  // Refresh session
  refreshSession: async () => {
    const { data, error } = await supabase.auth.refreshSession();
    if (error) throw error;
    return data;
  },
  
  // Get access token for backend API calls
  getAccessToken: async () => {
    const { data } = await supabase.auth.getSession();
    return data.session?.access_token || null;
  }
};

export default supabase; 